<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Responsáveis pela comissão no período."
    closeAriaLabel="Fechar"
    header="Gestores"
    [visible]="visivel()"
    (visibleChange)="visivel.set($event)"
    [style]="{ width: '560px', border: 'none' }"
    styleClass="dialogo-gestores-custom"
    appendTo="body"
    (onHide)="fechar()"
>
    <div [formGroup]="formulario" class="flex flex-col gap-4 py-2 px-1">
        <div class="flex flex-col gap-1.5">
            <label class="text-sm font-semibold text-color">Coordenador</label>
            <p-select class="w-full" formControlName="coordenador" [options]="opcoesMembros()" optionLabel="label" optionValue="value" placeholder="Selecionar Coordenador" [filter]="true" [showClear]="true" appendTo="body">
                <ng-template pTemplate="selectedItem" let-op>
                    @if (op) {
                        <div class="flex items-center gap-2 min-w-0">
                            <app-pessoa-avatar [idSolicitante]="idDaChavePessoa(op.value)" [uf]="ufDaChavePessoa(op.value)" [nome]="op.label" tamanho="sm"></app-pessoa-avatar>
                            <span class="truncate">{{ op.label }}</span>
                        </div>
                    }
                </ng-template>
                <ng-template pTemplate="item" let-op>
                    <div class="flex items-center gap-2 min-w-0">
                        <app-pessoa-avatar [idSolicitante]="idDaChavePessoa(op.value)" [uf]="ufDaChavePessoa(op.value)" [nome]="op.label" tamanho="xl"></app-pessoa-avatar>
                        <span class="truncate">{{ op.label }}</span>
                    </div>
                </ng-template>
            </p-select>
        </div>
        <div class="flex flex-col gap-1.5">
            <label class="text-sm font-semibold text-color">Secretário</label>
            <p-select class="w-full" formControlName="secretario" [options]="opcoesMembros()" optionLabel="label" optionValue="value" placeholder="Selecionar Secretário" [filter]="true" [showClear]="true" appendTo="body">
                <ng-template pTemplate="selectedItem" let-op>
                    @if (op) {
                        <div class="flex items-center gap-2 min-w-0">
                            <app-pessoa-avatar [idSolicitante]="idDaChavePessoa(op.value)" [uf]="ufDaChavePessoa(op.value)" [nome]="op.label" tamanho="sm"></app-pessoa-avatar>
                            <span class="truncate">{{ op.label }}</span>
                        </div>
                    }
                </ng-template>
                <ng-template pTemplate="item" let-op>
                    <div class="flex items-center gap-2 min-w-0">
                        <app-pessoa-avatar [idSolicitante]="idDaChavePessoa(op.value)" [uf]="ufDaChavePessoa(op.value)" [nome]="op.label" tamanho="xl"></app-pessoa-avatar>
                        <span class="truncate">{{ op.label }}</span>
                    </div>
                </ng-template>
            </p-select>
        </div>
        <div class="flex flex-col gap-1.5">
            <label class="text-sm font-semibold text-color">Assistente</label>
            <p-select class="w-full" formControlName="assistente" [options]="opcoesAssistentes()" optionLabel="label" optionValue="value" placeholder="Selecionar Assistente" [filter]="true" [showClear]="true" appendTo="body">
                <ng-template pTemplate="selectedItem" let-op>
                    @if (op) {
                        <div class="flex items-center gap-2 min-w-0">
                            <app-pessoa-avatar [idSolicitante]="idDaChavePessoa(op.value)" [uf]="ufDaChavePessoa(op.value)" [nome]="op.label" tamanho="sm"></app-pessoa-avatar>
                            <span class="truncate">{{ op.label }}</span>
                        </div>
                    }
                </ng-template>
                <ng-template pTemplate="item" let-op>
                    <div class="flex items-center gap-2 min-w-0">
                        <app-pessoa-avatar [idSolicitante]="idDaChavePessoa(op.value)" [uf]="ufDaChavePessoa(op.value)" [nome]="op.label" tamanho="xl"></app-pessoa-avatar>
                        <span class="truncate">{{ op.label }}</span>
                    </div>
                </ng-template>
            </p-select>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 pt-2">
            <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="fechar()"></button>
            <button type="button" pButton label="Confirmar" severity="primary" [appCan]="roleGerenciarConvidados" (click)="aoConfirmar()"></button>
        </div>
    </ng-template>
</p-dialog>
